"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonDualViewer = void 0;
const React = require("react");
const Table_1 = require("../Table");
const Card_1 = require("./Card");
const Selectors_1 = require("./Selectors");
const Controls_1 = require("./Controls");
const Notifications_1 = require("../Notifications");
const BronsonDualViewer = ({ configTable, configCard, configControl, configSelectors, configInitial, }) => {
    const isInitial = configInitial && configInitial.isInitial;
    const notification = configInitial && configInitial.notification;
    return (React.createElement(React.Fragment, null,
        React.createElement(Controls_1.BronsonControl, Object.assign({}, configControl)),
        React.createElement(Selectors_1.BronsonCheckSelectors, Object.assign({}, configSelectors)),
        isInitial ? (React.createElement("div", { className: 'u-pt u-mt', style: { borderTop: '3px solid #f2f2f2' } }, notification && React.createElement(Notifications_1.BronsonNotification, Object.assign({}, notification)))) : (React.createElement("div", { className: 'u-pt' }, configControl.cardViewActive ? (React.createElement(Card_1.BronsonCard, Object.assign({}, configCard))) : (React.createElement(Table_1.BronsonTable, { config: configTable }))))));
};
exports.BronsonDualViewer = BronsonDualViewer;
